import ODataModel from "sap/ui/model/odata/v4/ODataModel";
import ODataListBinding from "sap/ui/model/odata/v4/ODataListBinding";
import Context from "sap/ui/model/odata/v4/Context";
import ODataService from "ips/ac/base/service/ODataService";
import ODataContextBinding from "sap/ui/model/odata/v4/ODataContextBinding";
import Util from "ips/ac/util/Util";

export default class ODataModelHandler {

  public async create(path: string, data: any): Promise<void> {
    const dataModel: ODataModel = Util.getODataModel();
    const listBinding: ODataListBinding = dataModel.bindList(path);
    const context: Context = listBinding.create(data);
    await ODataService.submitBatch();
    await context.created();
    return context.getObject();
  }

  public async update(path: string, data: Record<string, unknown>): Promise<void> {
    const dataModel: ODataModel = Util.getODataModel();
    const contextBinding: ODataContextBinding = dataModel.bindContext(path);
    const context: Context = contextBinding.getBoundContext();
    for (const key in data) {
      context.setProperty(key, data[key]);
    }
    await ODataService.submitBatch();
    return context.getObject();
  }

  async remove(context: Context): Promise<void> {
    const deletePromise = context.delete();
    await ODataService.submitBatch();
    return await deletePromise;
  }
}